import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-requirements',
  templateUrl: './requirements.component.html',
  styleUrls: ['./requirements.component.scss']
})
export class RequirementsComponent implements OnInit {
  RESOURCE_SERVER_URL = environment.RESOURCE_SERVER_URL;
  generatePaymentIcon = this.RESOURCE_SERVER_URL + '/assets/images/process-claims/Claim-Review/PDF.svg';

  isLoading:boolean = false;
  requirementDetails = [];
  statusList: any;

  constructor(
    private commonService: CommonService
  ) { }

  async ngOnInit() {
    this.isLoading = true;
    this.requirementDetails = this.commonService.claimReviewPolicyDetails['requirements'];
    console.log('requirementDetails', this.requirementDetails);
    this.isLoading = false;
  }

}
